import { IoMdClose } from "react-icons/io";
import { Slider } from "@material-ui/core";
import { GrCircleInformation } from "react-icons/gr";
import { formatCurrency, formatCurrencyToNumber } from "utils/helper";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { Modal, Typography, Button, Radio } from "components";

const HighLowAgentModal = ({
  showModal,
  highLowAgentQuery,
  handleModalClose,
  handleMeasureByChange,
  handleHighLowAgentQueryChange,
}) => {
  const handleTransThreshChange = (type) => {
    let val = formatCurrencyToNumber(highLowAgentQuery.transThresh);
    val = type === "increase" ? val + 1 : val - 1;

    handleHighLowAgentQueryChange({
      name: "transThresh",
      value: formatCurrency(val),
    });
  };
  return (
    <Modal showModal={showModal} onClose={handleModalClose} customPadding={"0"}>
      <div className="report-filter-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => handleModalClose()}
            />
          </div>
          <Typography className={"text-center"}>
            Set Threshold for Report
          </Typography>
        </div>
        <div className="px-4" style={{ margin: "2rem 0" }}>
          <Typography
            state="primary"
            variant="caption2"
            className={"text-center mb-3"}
          >
            Set threshold for performance
          </Typography>
          <div className="performance-radio-container d-flex">
            <div>
              <Radio
                checked={highLowAgentQuery?.measureBy === 0}
                checkedState="primary"
                label={
                  <Typography
                    className="performance-select-label"
                    variant="caption1"
                  >
                    {"Use Transaction Volume"}
                  </Typography>
                }
                labelPosition="after"
                value={0}
                onClick={(e) => {
                  handleMeasureByChange(0);
                }}
              />
            </div>
            <div>
              <Radio
                checked={highLowAgentQuery.measureBy === 1}
                checkedState="primary"
                label={
                  <Typography
                    className="performance-select-label"
                    variant="caption1"
                  >
                    {"Use Transaction Value"}
                  </Typography>
                }
                labelPosition="after"
                value={1}
                onClick={(e) => {
                  handleMeasureByChange(1);
                }}
              />
            </div>
          </div>
          <div className="mt-3 performance-input-container">
            <div className="d-flex flex-column">
              <IoIosArrowUp
                className="amount-control-cta"
                onClick={() => handleTransThreshChange("increase")}
              />
              <input
                type="text"
                value={highLowAgentQuery.transThresh}
                onChange={(e) => {
                  const value = e.target.value;
                  handleHighLowAgentQueryChange({
                    name: "transThresh",
                    value:
                      formatCurrency(value).trim() === "₦"
                        ? ""
                        : formatCurrency(
                            value,
                            highLowAgentQuery.measureBy !== 0
                          ),
                  });
                }}
              />
              <IoIosArrowDown
                className="amount-control-cta"
                onClick={() => handleTransThreshChange()}
              />
            </div>
          </div>
        </div>
        <div className="px-4 mb-4">
          <Typography
            state="primary"
            variant="caption2"
            className={"text-center mb-3"}
          >
            Set the last number of days to check for performance
          </Typography>
          <Slider
            valueLabelDisplay="auto"
            value={highLowAgentQuery.threshold}
            onChange={(e, value) => {
              handleHighLowAgentQueryChange({
                name: "threshold",
                value,
              });
            }}
            size="large"
            style={{ width: "100%" }}
            color="primary"
            min={0}
            max={180}
          />
          <div className="filter-note">
            <span>Note that</span>{" "}
            <span>
              <GrCircleInformation />
            </span>{" "}
            <span>Maximum of 180 days (last 6 months) can be selected</span>
          </div>

          <Button
            label="Apply"
            size="xs"
            className={"mx-auto"}
            onClick={() => handleModalClose()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HighLowAgentModal;
